module.exports = __webpack_public_path__ + "img/dt2.5768a121.png";